
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 230","transform":"translate(-3489 886)"}},[_c('circle',{attrs:{"data-name":"楕円形 30","cx":"16","cy":"16","r":"16","transform":"translate(3489 -886)","fill":"#626262"}}),_c('path',{attrs:{"d":"M3512-862.8h-14v-9.9h14m0-4.5h-1v-1.8h-2v1.8h-8v-1.8h-2v1.8h-1a1.907 1.907 0 00-2 1.8v12.6a1.908 1.908 0 002 1.8h14a1.908 1.908 0 002-1.8v-12.6a1.908 1.908 0 00-2-1.8m-9.69 12.6l2.44-2.2 2.44 2.2 1.06-.954-2.44-2.2 2.44-2.2-1.06-.946-2.44 2.2-2.44-2.2-1.06.954 2.44 2.2-2.44 2.2z","fill":"#fff"}})])])
          )
        }
      }
    